<script>
    import { run } from 'svelte/legacy';

    import NavBtn from "./NavBtn.svelte";
    import Bar from "./Bar.svelte";
    /**
     * @typedef {Object} Props
     * @property {string} [damID]
     * @property {any} [data]
     * @property {any} parent
     */

    /** @type {Props} */
    let { damID = "0", data = [], parent } = $props();
    let showLeft = $state(false);
    let showRight = $state(true);
    let selectedDam = $state();
    let filteredDams = $state();
    let previousDam = $state();
    let nextDam = $state();
    let lastDam = $state();
    let err = $state();
    let content;

    let handleScrollRight = () => {
        let c = parent.querySelector(".wc-dam-cap__content");
        c.scrollLeft += 90;
        if (c.scrollWidth - c.clientWidth === c.scrollLeft) {
            showRight = false;
        }
        if (!showLeft) {
            showLeft = true;
        }
    };
    let handleScrollLeft = () => {
        let c = parent.querySelector(".wc-dam-cap__content");
        c.scrollLeft -= 90;
        if (!showRight) {
            showRight = true;
        }
        if (c.scrollLeft === 0) {
            showLeft = false;
        }
    };
    let damIndex = $derived(Number(damID));
    let len = $derived(data.length);
    run(() => {
        if (len < 4) {
            showLeft = false;
            showRight = false;
        } else {
            showRight = true;
        }
    });
    run(() => {
        if (damIndex && !selectedDam && !filteredDams && !err && len > 0) {
            let maybeDam = data.find((d) => d.id === damIndex);
            if (maybeDam) {
                lastDam = data[len - 1];
                let dataArrIndex = data.findIndex(i => i.id === damIndex);
                let before = data.slice(0, dataArrIndex + 1); 
                selectedDam = before.pop();
                let after = data.slice(dataArrIndex + 1, len);
                filteredDams = [...after, ...before];
                previousDam =
                    maybeDam.id > 1
                        ? filteredDams.find((d) => d.id === maybeDam.id - 1)
                        : lastDam;
                nextDam =
                    maybeDam.id < len - 1
                        ? filteredDams.find((d) => d.id === maybeDam.id + 1)
                        : filteredDams[0];
            } else {
                err = true;
            }
        }
    });
</script>

{#if !damIndex || err}
    <div class="wc-dam-cap__chart">
        <NavBtn isLeft={true} onclick={handleScrollLeft} disabled={!showLeft} />
        <div class="wc-dam-cap__container">
            <div class="wc-dam-cap__content" id={parent.id + 'content'}>
                {#if data}
                    {#each data as d}
                        <Bar
                            link={d.link}
                            percent={d.percent}
                            name={d.name}
                            parentId={parent.id + 'content'} />
                    {/each}
                {/if}
            </div>
        </div>
        <NavBtn
            isLeft={false}
            onclick={handleScrollRight}
            disabled={!showRight} />
    </div>
{:else if data.length > 0}
    <div class="wc-dam-cap__chart">
        <NavBtn isLeft={true} onclick={handleScrollLeft} disabled={!showLeft} />
        <div class="wc-dam-cap__container">
            <div class="wc-dam-cap__content" id={parent.id + 'content'}>
                <div class="wc-dam-cap__selected">
                    {#if selectedDam}
                        <Bar
                            percent={selectedDam.percent}
                            name={selectedDam.name}
                            link={selectedDam.link} />
                    {/if}
                </div>
                {#if filteredDams}
                    {#each filteredDams as d}
                        <Bar
                            link={d.link}
                            percent={d.percent}
                            name={d.name}
                            parentId={parent.id + 'content'} />
                    {/each}
                {:else}...fetching data{/if}
            </div>
        </div>
        <NavBtn
            isLeft={false}
            onclick={handleScrollRight}
            disabled={!showRight} />
    </div>
{:else}
    <div class="wc-dam-cap__chart">
        <div class="wc-dam-cap__container">
            <div class="wc-dam-cap__content" id={parent.id + 'content'}>
                {#if data}
                    {#each data as d}
                        <Bar
                            link={d.link}
                            percent={d.percent}
                            name={d.name}
                            parentId={parent.id + 'content'} />
                    {/each}
                {:else}...fetching data{/if}
            </div>
        </div>
    </div>
{/if}
